import { state, update } from 'bey-fix'

const user = state({
  id: null,
  name: null,
  email: null,
})

export const setUser = ({ id, name, email }) =>
  update(user, (state) => ({ id, name, email }))

export const updateUserName = (name) =>
  update(user, (state) => {
    if (name) {
      state.name = name
    }
  })

export const updateUserEmail = (email) =>
  update(user, (state) => {
    if (email) {
      state.email = email
    }
  })

export default user
